/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Cps_Include_SpacesInputs */

const en_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const fr_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const de_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const it_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const ru_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const es_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const zh_cn2_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const ja_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const hi_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

const pt_pt2_options_metrics_cps_include_spaces = /** @type {(inputs: Options_Metrics_Cps_Include_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Spaces In CPS`)
};

/**
* | output |
* | --- |
* | "Include Spaces In CPS" |
*
* @param {Options_Metrics_Cps_Include_SpacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_cps_include_spaces = /** @type {((inputs?: Options_Metrics_Cps_Include_SpacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Cps_Include_SpacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_cps_include_spaces(inputs)
	if (locale === "de") return de_options_metrics_cps_include_spaces(inputs)
	if (locale === "it") return it_options_metrics_cps_include_spaces(inputs)
	if (locale === "ru") return ru_options_metrics_cps_include_spaces(inputs)
	if (locale === "es") return es_options_metrics_cps_include_spaces(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_cps_include_spaces(inputs)
	if (locale === "ja") return ja_options_metrics_cps_include_spaces(inputs)
	if (locale === "hi") return hi_options_metrics_cps_include_spaces(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_cps_include_spaces(inputs)
	return en_options_metrics_cps_include_spaces(inputs)
});